/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { Status } from 'components';
import { OnrampLayout } from './components';

export const Failure = () => {
  const { spacing } = useTheme();

  return (
    <OnrampLayout
      topChildren={
        <div>
          <Status
            heading={'Uh oh...'}
            subHeading="Something is not right"
            imageProps={{
              name: 'unplugged',
              size: spacing.xxl,
              showPlaceholder: false,
            }}
          />
        </div>
      }
    />
  );
};

export default Failure;
